import React, { useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Pagination,
  Paper,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getDevelopers } from "../../features/Developers/developerSlice";
import { useState } from "react";

const Devs = () => {
  const pageSize = 5;
  const [search, setSearch] = useState({ text: "" });
  const [pagination, setPagination] = useState({
    from: 0,
    to: pageSize,
    count: 0,
  });
  let { developers, developer, pending } = useSelector(
    (state) => state.developers
  );
  const dispatch = useDispatch();

  const developersPerPage = developers?.slice(pagination?.from, pagination?.to);
  useEffect(() => {
    dispatch(getDevelopers());
    setPagination({ ...pagination, count: developers.length });
    // let developersPerPage = developers.slice(pagination.from, pagination.to);
  }, []);

  // useEffect(()=>{

  // })

  const handlePaginationChange = (event, page) => {
    const from = (page - 1) * pageSize;
    const to = (page - 1) * pageSize + pageSize;
    setPagination({ ...pagination, from: from, to: to });
  };

  const handleSearch = (e) => {
    setSearch({ ...search, text: e.target.value });
  };

  return (
    <>
      <Container>
        <Box>
          <Box maxWidth="lg" sx={{ mt: 3 }}>
            <Paper>
              {!pending ? (
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  {!pending ? (
                    <Typography component="h2">List of All Devs</Typography>
                  ) : (
                    <Skeleton
                      animation="wave"
                      height={20}
                      // style={{ marginBottom: 6 }}
                      p={3}
                      m={2}
                      width="100%"
                    />
                  )}
                  {!pending ? (
                    <TextField
                      id="standard-basic"
                      label="Search dev"
                      variant="standard"
                      onChange={handleSearch}
                    />
                  ) : (
                    <Skeleton
                      animation="wave"
                      height={20}
                      // style={{ marginBottom: 6 }}
                      p={3}
                      m={2}
                      width="100%"
                    />
                  )}
                </Box>
              ) : (
                <Skeleton
                  variant="rectangle"
                  animation="wave"
                  height={100}
                  // style={{ marginBottom: 6 }}
                  p={3}
                  m={2}
                  width="100%"
                />
              )}
            </Paper>
          </Box>
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container spacing={1}>
              {developers?.length > 0 &&
                developersPerPage
                  .filter((item) => {
                    return search.text.toLowerCase() === ""
                      ? item
                      : item?.attributes?.username?.includes(search?.text);
                  })
                  .map((developer) => {
                    const { attributes, skills, projects, home, socials } =
                      developer;
                    return (
                      <Grid item xs={6} md={4} lg={3}>
                        <Link to={`/devs/${attributes.id}`} underline="none" s>
                          <Card sx={{ maxWidth: 345 }}>
                            {!pending ? (
                              <CardMedia
                                component="img"
                                height="140"
                                image={`${attributes?.photoUrl}`}
                                alt="green iguana"
                                href={`/devs/${attributes?.id}`}
                              />
                            ) : (
                              <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width={345}
                                height={118}
                              />
                            )}
                            <CardContent>
                              {!pending ? (
                                <Typography
                                  gutterBottom
                                  variant="h5"
                                  component="div"
                                  sx={{ textAlign: "center" }}
                                >
                                  {attributes?.username}
                                </Typography>
                              ) : (
                                <Skeleton animation="wave" height={50} p={2} />
                              )}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                }}
                              >
                                {!pending ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {skills.length}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Skills{" "}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Skeleton
                                    animation="wave"
                                    height={20}
                                    // style={{ marginBottom: 6 }}
                                    p={3}
                                    m={2}
                                    width="100%"
                                  />
                                )}
                                {!pending ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography variant="body2">
                                      {`${projects.length}  `}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Projects
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Skeleton
                                    animation="wave"
                                    height={20}
                                    // style={{ marginBottom: 6 }}
                                    p={3}
                                    m={2}
                                    width="100%"
                                  />
                                )}
                              </Box>
                            </CardContent>
                            {/* <CardActions>
                            <Button size="small">Share</Button>
                            <Button size="small">Learn More</Button>
                          </CardActions> */}
                          </Card>
                        </Link>
                      </Grid>
                    );
                  })}
            </Grid>
          </Box>
        </Box>
        <Box
          p={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Pagination
            count={Math.ceil(pagination.count / pageSize)}
            onChange={handlePaginationChange}
            variant="outlined"
            color="secondary"
          />
        </Box>
      </Container>
    </>
  );
};

export default Devs;
